function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paragraph/paragraph
 */
import ParagraphCommand from './paragraphcommand';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * The paragraph feature for the editor.
 *
 * It introduces the `<paragraph>` element in the model which renders as a `<p>` element in the DOM and data.
 *
 * @extends module:core/plugin~Plugin
 */

var Paragraph = /*#__PURE__*/function (_Plugin) {
  _inherits(Paragraph, _Plugin);

  var _super = _createSuper(Paragraph);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _super.apply(this, arguments);
  }

  _createClass(Paragraph, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var model = editor.model;
      var data = editor.data;
      editor.commands.add('paragraph', new ParagraphCommand(editor)); // Schema.

      model.schema.register('paragraph', {
        inheritAllFrom: '$block'
      });
      editor.conversion.elementToElement({
        model: 'paragraph',
        view: 'p'
      }); // Content autoparagraphing. --------------------------------------------------
      // Handles element which has not been converted by any plugin and checks if it would be converted if
      // we wrap it in a paragraph or change it to a paragraph.

      editor.conversion["for"]('upcast').elementToElement({
        model: function model(viewElement, modelWriter) {
          if (!Paragraph.paragraphLikeElements.has(viewElement.name)) {
            return null;
          } // Do not auto-paragraph empty elements.


          if (viewElement.isEmpty) {
            return null;
          }

          return modelWriter.createElement('paragraph');
        },
        converterPriority: 'low'
      });
      data.upcastDispatcher.on('element', function (evt, data, conversionApi) {
        // Do not try auto-paragraphing if the element was already converted.
        if (!conversionApi.consumable.test(data.viewItem, {
          name: data.viewItem.name
        })) {
          return;
        } // If the element is not paragraph-like try wrapping it in a paragraph.


        if (isParagraphable(data.viewItem, data.modelCursor, conversionApi.schema)) {
          Object.assign(data, wrapInParagraph(data.viewItem, data.modelCursor, conversionApi));
        }
      }, {
        priority: 'low'
      }); // Handles not converted text nodes and checks if would be converted if we wraps then by a paragraph.

      data.upcastDispatcher.on('text', function (evt, data, conversionApi) {
        // When node is already converted then do nothing.
        if (data.modelRange) {
          return;
        }

        if (isParagraphable(data.viewItem, data.modelCursor, conversionApi.schema)) {
          Object.assign(data, wrapInParagraph(data.viewItem, data.modelCursor, conversionApi));
        }
      }, {
        priority: 'lowest'
      }); // Empty roots autoparagraphing. -----------------------------------------------
      // Post-fixer which takes care of adding empty paragraph elements to empty roots.
      // Besides fixing content on #changesDone we also need to handle editor.data#ready event because
      // if initial data is empty or setData() wasn't even called there will be no #change fired.

      model.document.registerPostFixer(function (writer) {
        return _this._autoparagraphEmptyRoots(writer);
      });
      editor.data.on('ready', function () {
        model.enqueueChange('transparent', function (writer) {
          return _this._autoparagraphEmptyRoots(writer);
        });
      }, {
        priority: 'lowest'
      });
    }
    /**
     * Fixes all empty roots.
     *
     * @private
     * @returns {Boolean} `true` if any change has been applied, `false` otherwise.
     */

  }, {
    key: "_autoparagraphEmptyRoots",
    value: function _autoparagraphEmptyRoots(writer) {
      var model = this.editor.model;

      var _iterator = _createForOfIteratorHelper(model.document.getRootNames()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rootName = _step.value;
          var root = model.document.getRoot(rootName);

          if (root.isEmpty && root.rootName != '$graveyard') {
            // If paragraph element is allowed in the root, create paragraph element.
            if (model.schema.checkChild(root, 'paragraph')) {
              writer.insertElement('paragraph', root);
              return true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Paragraph';
    }
  }]);

  return Paragraph;
}(Plugin);
/**
 * A list of element names which should be treated by the autoparagraphing algorithms as
 * paragraph-like. This means that e.g. the following content:
 *
 *		<h1>Foo</h1>
 *		<table>
 *			<tr>
 *				<td>X</td>
 *				<td>
 *					<ul>
 *						<li>Y</li>
 *						<li>Z</li>
 *					</ul>
 *				</td>
 *			</tr>
 *		</table>
 *
 * contains five paragraph-like elements: `<h1>`, two `<td>`s and two `<li>`s.
 * Hence, if none of the features is going to convert those elements the above content will be automatically handled
 * by the paragraph feature and converted to:
 *
 *		<p>Foo</p>
 *		<p>X</p>
 *		<p>Y</p>
 *		<p>Z</p>
 *
 * Note: The `<td>` containing two `<li>` elements was ignored as the innermost paragraph-like elements
 * have a priority upon conversion.
 *
 * @member {Set.<String>} module:paragraph/paragraph~Paragraph.paragraphLikeElements
 */


export { Paragraph as default };
Paragraph.paragraphLikeElements = new Set(['blockquote', 'dd', 'div', 'dt', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'p', 'td']);

function wrapInParagraph(input, position, conversionApi) {
  var paragraph = conversionApi.writer.createElement('paragraph');
  conversionApi.writer.insert(paragraph, position);
  return conversionApi.convertItem(input, conversionApi.writer.createPositionAt(paragraph, 0));
}

function isParagraphable(node, position, schema) {
  var context = schema.createContext(position); // When paragraph is allowed in this context...

  if (!schema.checkChild(context, 'paragraph')) {
    return false;
  } // And a node would be allowed in this paragraph...


  if (!schema.checkChild(context.push('paragraph'), node)) {
    return false;
  }

  return true;
}